import ListGroup from "react-bootstrap/ListGroup";

import { useDispatch, useSelector } from "react-redux";

import NavBar from "./NavBar";
import "./shoppingCart.css";
import { Link } from "react-router-dom";
import {
  deleteProduct,
  deleteAllProduct,
  addQuantity,
} from "../Redux/shoppingCartSlice";

function ShoppingCart() {
  const dispatch = useDispatch();
  const shoppingCart = useSelector((state) => state.shoppingCart);
  const totalPrice = shoppingCart
    .map((item) => Number(item.price) * item.quantity)
    .reduce((prev, curr) => prev + curr, 0);

  const deleteOneProduct = (itemId) => {
    dispatch(deleteProduct(itemId));
  };

  const deleteProducts = (itemId) => {
    dispatch(deleteAllProduct(itemId));
  };

  const addMoreProducts = (itemId) => {
    dispatch(addQuantity(itemId));
  };

  return (
    <>
      <NavBar />
      <div className="container">
        <h1 className="shop-title mb-3 h3 text-start">SHOPPING CART</h1>
        {/* <div className="d-flex "> */}

        <div className=" row  ">
          <hr className="fw-bold" />
          <ListGroup className=" col-12 col-md-8 pe-2" as="ul">
            {shoppingCart.map((item) => {
              return (
                <>
                  <ListGroup.Item
                    key={item.id}
                    className="d-flex  productos align-items-start justify-content-between col-10"
                  >
                    <img
                      src={`
                              ${process.env.REACT_APP_FILES_URL}/${item.image}
                            `}
                      className=" img-thumbnail  "
                      alt=""
                    />

                    <div className=" ms-5 me-5 namePrice d-flex flex-column ">
                      <h6 className="fw-bold  text-start productName">
                        {item.name}
                      </h6>
                      <p className=" h6 text-start"> US$ {item.price}</p>
                      <i
                        onClick={() => deleteProducts(item.id)}
                        className="fa-solid fa-trash-can text-start  mt-5 fs-5 "
                        type="button"
                      ></i>
                    </div>
                    <div
                      className="btn-group plusMinus "
                      role="group"
                      aria-label="Basic example"
                    >
                      <button
                        onClick={() => deleteOneProduct(item.id)}
                        type="button"
                        className="border"
                      >
                        <i className="fa-solid fa-minus"></i>
                      </button>
                      <span className="border p-2"> {item.quantity}</span>

                      {item.stock - item.quantity > 0 && (
                        <button
                          onClick={() => addMoreProducts(item.id)}
                          type="button"
                          className="border"
                        >
                          <i className="fa-solid fa-plus"></i>
                        </button>
                      )}
                    </div>
                  </ListGroup.Item>
                  {item.stock - item.quantity < 1 && (
                    <p className="text-danger text-end">We ran out of stock</p>
                  )}

                  <hr className="fw-bold" />
                </>
              );
            })}

            <Link to="/category/1" className="text-decoration-none">
              <p className="text-end text-dark">
                <i className="fa-solid fa-circle-arrow-left text-dark me-2 "></i>
                Return to Shop
              </p>
            </Link>
          </ListGroup>
          <div className="col-12 col-md-4  d-flex flex-column  pb-3 ">
            <div className="d-flex flex-column border p-4">
              <h3 className="text-start h6 fw-bold">Cart Total</h3>
              <hr className="fw-bold" />

              <div className="d-flex justify-content-between">
                <p className="text-start">Subtotal: </p>
                <p>
                  <strong> US$ {totalPrice.toFixed(2)}</strong>
                </p>
              </div>
              <div className="d-flex justify-content-between">
                <p className="text-start">Total: </p>
                <p>
                  <strong> US$ {totalPrice.toFixed(2)}</strong>
                </p>
              </div>
              <Link to={"/checkout"} className="text-decoration-none ">
                <button
                  type="button"
                  className="btn btn-dark pt-1 pb-1 checkOutButton rounded-pill  btn-block "
                >
                  <small> Proceed to checkout</small>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ShoppingCart;
